module.exports = __webpack_public_path__ + "04_mole.1bfdcc83.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer2/04_mole.png
// module id = 7Ssm
// module chunks = 0